const ToastConstants = {
    SET_TOAST: 'SET_TOAST',
    DISABLE_TOAST: 'DISABLE_TOAST',
};

export default ToastConstants;